module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"drop":"วางไฟล์เพื่ออัพโหลด","btn":{"upload":{"image":"เลือกรูปภาพ","file":"เลือกไฟล์"},"save":"บันทึก","cancel":"ยกเลิก"}},"en":{"drop":"Drop files to upload","btn":{"upload":{"image":"Select image","file":"Select file"},"save":"Save","cancel":"Cancel"}}}')
  delete Component.options._Ctor
}
